export type TAppType = 'Desktop' | 'Mobile';

export const featureKey = 'setting';

export interface ICustomerQuote {
  name: string;
  initials: string;
  color: string;
  stars: number;
  text: string;
}

export interface IState {
  appType: TAppType;
  buttonClickDelayMs: number;
  validToken: boolean;
  customerQuotes: Array<ICustomerQuote>;
}

export const initialState: IState = {
  appType: 'Desktop',
  buttonClickDelayMs: 200,
  validToken: false,
  customerQuotes: [
    {
      name: 'Emily',
      initials: 'E',
      stars: 5,
      color: 'red',
      text: `I was blown away by how spot-on the 10-min assessment was. It highlighted the same deficiencies my lab tests showed. Mark makes it simple and trustworthy.`,
    },
    {
      name: 'Ryan F.',
      initials: 'RF',
      stars: 5,
      color: 'blue',
      text: `Honestly, I’ve spent $$$ on labs in the past. Mark gave me a clear, science-based report in minutes. Saved me time, money, and stress.`,
    },
    {
      name: 'Hannah D.',
      initials: 'HD',
      stars: 5,
      color: 'yellow',
      text: `I love that! Assessment, personalized protocol, and the supplements delivered to my door. Super convenient.`,
    },
    {
      name: 'Daniel',
      initials: 'D',
      stars: 4,
      color: 'red',
      text: `As someone who’s very picky about health tools, I appreciate that Mark uses medical protocols and science-backed data. The doses feel right, and the combinations make sense.`,
    },
    {
      name: 'Samantha S.',
      initials: 'SS',
      stars: 5,
      color: 'blue',
      text: `Ordered my personalized supplements right after the assessment. Package arrived quickly, and I loved how everything was explained clearly on the labels.`,
    },
    {
      name: 'Tyler W.',
      initials: 'TW',
      stars: 4,
      color: 'yellow',
      text: `Not every app feels this personal. Mark tailored the plan to my lifestyle and even considered allergies. That gave me confidence it’s safe and actually for me.`,
    },
    {
      name: 'Michael S.',
      initials: 'MS',
      stars: 5,
      color: 'red',
      text: `After 3 weeks on the Mark protocol, I feel more energized and focused. It’s refreshing to finally have guidance that’s not guesswork but backed by real science.`,
    },
    {
      name: 'Anna',
      initials: 'A',
      stars: 4,
      color: 'blue',
      text: `Mark’s plans are super simple to follow, and they've really helped me get my energy back and feel more balanced.`,
    },
    {
      name: 'Sarah K.',
      initials: 'SK',
      stars: 5,
      color: 'yellow',
      text: `A trusted wellness companion with quality and vetted vitamins.<br/>I’ve had a very positive experience using Mark: Wellness Assistance. The platform offers a thoughtful, user-friendly approach to well-being, with features that truly make a difference.`,
    },
    {
      name: 'Svit M.',
      initials: 'SM',
      stars: 4,
      color: 'red',
      text: `I recently started my personalized supplement and vitamin plan with Mark — and honestly, I didn’t expect to feel a difference so soon. But  I actually do. My energy is up, my mood’s more stable, and it feels like real change — not just a placebo .`,
    },
  ],
};
